module.exports = __webpack_public_path__ + "img/member_5.4606ceff.png";